module.exports = __webpack_public_path__ + "static/media/gymnase_casalis2.84ede8fb.jpg";